// src/auth/AuthContext.jsx

import React, { createContext, useState, useEffect } from 'react';
import client from '../api/client';

export const AuthContext = createContext();
const STORAGE_KEY = 'parent_basic_auth';

export function AuthProvider({ children }) {
  // 初期値を localStorage によって決定
  const [isAuthenticated, setAuthenticated] = useState(
    () => !!localStorage.getItem(STORAGE_KEY)
  );

  // 1) 起動時に localStorage をチェック
  // useEffect は axios ヘッダセットだけに使う
  useEffect(() => {
    const token = localStorage.getItem(STORAGE_KEY);
    if (token) {
      client.defaults.headers.common['Authorization'] = `Basic ${token}`;
    }
  }, []);

  // ログイン処理
  const login = async (username, password) => {
    const token = btoa(`${username}:${password}`);
    // ヘッダーと localStorage に同時設定
    client.defaults.headers.common['Authorization'] = `Basic ${token}`;
    localStorage.setItem(STORAGE_KEY, token);
    setAuthenticated(true);
    return true;
  };

  // ログアウト処理
  const logout = () => {
    delete client.defaults.headers.common['Authorization'];
    localStorage.removeItem(STORAGE_KEY);
    setAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
